// calculateTotalPlateCosts.js

export function calculateTotalPlateCost(object) {
  console.log("Plate object :", object)
  if (object.selectedProduct.machine === "Arsoma") {
    let cmyk = object.selectedProduct.print.cmykColors
    let pantone = object.selectedProduct.print.pantoneColors
    let white = object.selectedProduct.print.coveringWCount
    let varnish = object.selectedProduct.print.varnishUse
    let silverOrGold = object.selectedProduct.print.goldOrSilver
    let relief = object.selectedProduct.print.relief === "No" ? 0 : 1
    let total = cmyk + pantone + white + varnish + silverOrGold + relief
    return total * 30
  } else if (object.selectedProduct.machine === "Viva") {
    let white = object.selectedProduct.print.coveringWCount
    let relief = object.selectedProduct.print.relief === "No" ? 0 : 1
    let varnish = object.selectedProduct.print.varnishUse
    let silverOrGold = object.selectedProduct.print.goldOrSilver
    let totalCostFlexo = (white + varnish + silverOrGold) * 30
    let totalCostHotPrint = object.selectedProduct.print.foilCount * 100
    let totalCostEmbossing = relief * 150
    return totalCostFlexo + totalCostHotPrint + totalCostEmbossing
  } else {
    return 0
  }
}
